import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { MENU_INFO_ROUTES } from '@/navigators/routes';
import { MenuDetailComponent } from '@/components/menu/menu-detail-component';
import { MenuStackParams } from '@/navigators/types';
import { PageContainer } from '@/components/page-container';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';

export const MenuDetailScreen: React.FC = () => {
  const [showAddMenuItemSheet, setShowAddMenuItemSheet] = useState(false);
  const { navigate } = useNavigation<StackNavigationProp<MenuStackParams>>();

  return (
    <PageContainer
      animateNavigationHeader
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: i18n.t('menu'),
      }}
    >
      {(scrollViewProps) => (
        <MenuDetailComponent
          onMenuItemSelect={(menuItemUUID) =>
            navigate(MENU_INFO_ROUTES.ItemDetail, {
              menuItemUUID,
            })
          }
          scrollViewProps={scrollViewProps}
          setShowAddMenuItemSheet={setShowAddMenuItemSheet}
          showAddMenuItemSheet={showAddMenuItemSheet}
        />
      )}
    </PageContainer>
  );
};
